import { useStaticQuery, graphql } from 'gatsby'

import { InquiryWidget, NewsItem, PressItem } from '../types/press'
import usePageData from './usePageData'

interface QueryResults {
  allNewsItems: {
    nodes: NewsItem[]
  }
  allPressItems: {
    nodes: PressItem[]
  }
  contentfulPressPage: {
    inquiryWidget: InquiryWidget
  }
}

interface PressPageData {
  newsItems: {
    nodes: NewsItem[]
  }
  pressItems: {
    nodes: PressItem[]
  }
  contentfulPressPage: {
    inquiryWidget: InquiryWidget
  }
}

/**
 * usePressPageData is a function that returns news and press article lists and landing page
 * enquiry widget info associated with a particular brand.
 */
// This function currently returns the TopResume specific data for TopResume and
// returns all data for other brands
export default function usePressPageData(): PressPageData {
  const { brand } = usePageData()

  const query = graphql`
    query pressPageQuery {
      allNewsItems: allContentfulNewsItem(
        sort: { order: DESC, fields: publishDate }
      ) {
        nodes {
          ...NewsItems
        }
      }
      allPressItems: allContentfulPressItem(
        sort: { order: DESC, fields: publishedDate }
      ) {
        nodes {
          ...PressItems
        }
      }
      contentfulPressPage {
        inquiryWidget {
          email
          contactName
        }
      }
    }
  `
  const pressPageData = useStaticQuery<QueryResults>(query)

  const { allNewsItems, allPressItems, contentfulPressPage } = pressPageData

  return {
    newsItems: allNewsItems,
    pressItems: {
      nodes: allPressItems.nodes.filter(
        (item) => item.brand.name.toLowerCase() === brand?.name.toLowerCase()
      ),
    },
    contentfulPressPage,
  }
}
